export default __webpack_public_path__ + "static/media/5.04c356b7.png";